import React from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';
import parse from 'html-react-parser';
import { useTranslation } from "react-i18next";

/**
 * RadioGroup:
 *  - Generic Input-Switch Component
 */
export function RadioGroup(props) {
  const onChange = (key) => props.onChange(key);

  const {
    t,
    // i18n
  } = useTranslation("translation");

  const radioChecked = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="9.5" stroke="#003E6B" fill="white" />
      <circle cx="10" cy="10" r="7" fill="#003E6B"/>
    </svg>
  );

  const radioUnchecked = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="9.5" stroke="#003E6B" fill="white"/>
    </svg>
  );

  return (
    <div className={cname['radioGroup-container']}>
      <fieldset className={cname.fieldset}>
        <legend>{parse(t(`${props.radioGroupLabel}.string`))}</legend>
        <div className={cname['radioGroup-wrap']}>
          {props.radios.map((radio, key)=>(
          <div key={key} className={cname.switch}>
            <div className={cname.RadioGroup}>
              <div className={props.className} 
                onClick={()=>props.onChange(key)}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    props.onChange(key)
                  }
                }}
              >
                <input
                  id={radio.value}
                  type='radio'
                  name={radio.name}
                  className={radio.name}
                  value={radio.value}
                  onChange={()=>onChange(key)}
                  checked={(key === props.radioGroupChecked)}
                  aria-label={t(`${radio.ariaLabel}.string`)}
                />
                {(key === props.radioGroupChecked)?radioChecked:radioUnchecked}
              </div>
            </div>
            <label htmlFor={radio.value} className={props.className}>
              <p style={{margin: 0}}>{parse(t(`${radio.label}.string`))}</p>
            </label>
          </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
}

RadioGroup.propTypes = {
  /**
   * Radio group label string
   */
  radioGroupLabel: PropTypes.string.isRequired,
  /**
   * Array of radio objects
   */
  radios: PropTypes.array,
  /**
   * Index of the currently selected radio group item
   */
  radioGroupChecked: PropTypes.number,
  /**
   * Callback for when switch value changes
   */
  className: PropTypes.string,
  /**
   * Callback function to adjust the current radio group selection
   */
  onChange: PropTypes.func,
};

RadioGroup.defaultProps = {
  radioGroupLabel: '',
  radios: [],
  radioGroupChecked: '',
  className: ''
};
